import React, { FC, useMemo } from 'react';
import { CompleteWizardBanner } from '@app/screens/liquidity/LiquidityWizard/components/CompleteStep/components/CompleteWizardBanner';
import { useToggle } from 'react-use';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { AddToNitroView } from '@app/screens/liquidity/LiquidityWizard/components/CompleteStep/components/AddToNitroView';
import { useDerivedLiquidityByIchiInfo } from '@app/state/liquidityByIchiStore';
import { useDerivedSteerInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedSteerMintInfo';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { Box, Text } from '@chakra-ui/react';
import { useScrollTop } from '@app/hooks/other/useScrollTop';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const CompleteStep: FC<Props> = ({ mintInfo }) => {
  useScrollTop(true);

  const [isNitroView, toggleNitroView] = useToggle(false);
  const { strategy, mode, provider, tokenId } = useLiquidityWizardState();

  const ichiMintInfo = useDerivedLiquidityByIchiInfo(mintInfo.poolAddress);
  const steerMinInfo = useDerivedSteerInfo(mintInfo.poolAddress);

  const isNitroAvailable = useMemo(() => {
    if (mode === 'manual') {
      return false;
    }

    if (provider === 'steer') {
      return steerMinInfo.isNitroPool;
    }

    if (provider === 'ichi') {
      return ichiMintInfo.isNitroPool;
    }

    return false;
  }, [ichiMintInfo, steerMinInfo, mode, provider]);

  return (
    <>
      {isNitroView ? (
        <Box maxWidth={768} mx="auto" mt={8}>
          <Text as="h4" fontSize={18} fontWeight={600}>
            This pool has NITRO!
          </Text>
          <Text fontSize={14} my={4}>
            Coincidentally, this pool has additional incentives available for
            you. If you would like to receive these incentives, you will have to
            lock and stake this position. Please read details of the lock and
            stake below.
          </Text>
          <AddToNitroView
            mintInfo={mintInfo}
            ichiMintInfo={ichiMintInfo}
            steerMintInfo={steerMinInfo}
          />
        </Box>
      ) : (
        <CompleteWizardBanner
          onComplete={() => toggleNitroView(true)}
          isNitroAvailable={!!(isNitroAvailable && tokenId)}
        />
      )}
    </>
  );
};
